import "./App.css";

import Hero from "./components/Hero";
import Problems from "./components/Problems";
import Benefits from "./components/Benefits";
import Sell from "./components/Sell";
import About from "./components/About";
import Faq from "./components/FAQ";
import Footer from "./components/Footer";

export default function App() {
  return (
    <div>
      <Hero />
      <Problems />
      <Benefits />
      <Sell />
      <About />
      <Faq />
      <Footer />
    </div>
  );
}
